// import React, { useContext, useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import expertDefaultImg from "../../images/expert-default.png";
// import SendInmail from "./SendInmail";
// import SendEmail from "./SendEmail";
// import SendFollowUpEmail from "./SendFollowUpEmail";
// import EditProfileBasic from "./EditProfileBasic";
// import ExAvailabilityComment from "./ExAvailabilityComment";
// import ExExperience from "./ExExperience";
// import ExHourlyRate from "./ExHourlyRate";
// import ExDailyRate from "./ExDailyRate";
// import ExPhoneNumber from "./ExPhoneNumber";
// import ProjectExpertStatus from "./ProjectExpertStatus";
// import ProjectExpertType from "./ProjectExpertType";
// import ExShortProfile from "./ExShortProfile";
// import ProjectExpertIsVip from "./ProjectExpertIsVip";
// import ExZohoBtn from "./ExZohoBtn";
// import ExMaxWorkingDays from "./ExMaxWorkingDays";
// import ProjectExpertDelete from "./ProjectExpertDelete";
// import ExSummary from "./ExSummary";
// import ExContactedDate from "./ExContactedDate";
// import ExCreateDigitalPPT from "./ExCreateDigitalPPT";
// import ExAddedDate from "./ExAddedDate";
// import ExAvailabilityDate from "./ExAvailabilityDate";
// import LogInmail from "./LogInmail";
// import LogCalls from "./LogCalls";
// import SendNDA from "./SendNDA";
// import ConnectionBtn from "./ConnectionBtn";
// import ExEmailChange from "./ExEmailChange";
// import AppointmentScheduler from "./AppointmentCreator";
// import AddToProject from "../ExpertDetails/AddToProject";
// import ProjectScreeningQueAns from "./ProjectScreeningQueAns";
// import { UserContext } from "../../contexts/UserContext";
// import { UrlContext } from "../../contexts/UrlContext";
// import Swal from "sweetalert2";
// import loadingIcon from "../../images/Loading_icon.gif";
// import AvailabilityCalendar from "../ConsultantProjects/AvailabilityCalendar";
// import InviteToProject from "./InviteToProject";
// import ProjectExpertIsVerified from "./ProjectExpertIsVerified";
// import { use } from "react";
// import ComposeNewEmail from "../../components/EmailUI/ComposeNewEmail";
// import { get } from "jquery";
// import { de } from "date-fns/locale";
// import ModifyProjectDeadline from "./ModifyDeadline";
// import EphCalendar from "../../components/ProjectDetails/EphCalendar";

// export default function ProjectExpertRow({
//   data,
//   project_id,
//   appendExpertId,
//   removeExpertId,
//   project_name,
//   backupData,
//   setBackupData,
//   setEmailButtonClicked,
//   setSelectedConsulData,
//   setEmailDetails,
//   setComposeEmail,
//   fieldsLoading,
//   screeningQuestions,
//   projectType,
//   expertIDs,
//   tableData,
//   setTableData,
//   doRefresh,
//   setDoRefresh,
//   currentExpertID,
//   setCurrentExpertID,
//   username,
// }) {
//   const [hideDeletedRow, setHideDeletedRow] = useState(false);
//   const [exObject, setExObject] = useState({
//     expertName: "",
//     expertLink: "",
//     expertEmail: "",
//   });
//   const [isCreateNewOpen, setIsCreateNewOpen] = useState(false);
//   const [openCallDetails, setOpenCallDetails] = useState(false);
//   const [partiallyAvailable, setPartiallyAvailable] = useState(false);
//   const [availablityDate, setAvailablityDate] = useState(null);
//   const [availabiltyBorder, setAvailabiltyBorder] = useState("");
//   const [NDAStatus, setNDAStatus] = useState("");
//   const [newStatus, setNewStatus] = useState("");
//   const [summLength, setSummLength] = useState(0);
//   const [showSummAlert, setShowSummAlert] = useState(false);
//   const [availabilityComment, setAvailabilityComment] = useState(null);
//   const [showComment, setShowComment] = useState(false);
//   const [exContactedBy, setExContactedBy] = useState(null);
//   const [exContactedMethod, setExContactedMethod] = useState(null);
//   const [exDateCreated, setExDateCreated] = useState(null);
//   const [exSavedBy, setExSavedBy] = useState(null);
//   const [verified, setVerified] = useState(true);

//   const [availabilityPopup, setAvailabilityPopup] = useState(false);
//   const [availability, setAvailability] = useState([]);
//   const [invitationRequest, setInvitationRequest] = useState(false);
//   const [loadingInvitation, setLoadingInvitation] = useState(false);
//   const [inviteName, setInviteName] = useState("");
//   const mediaLink = "https://media.licdn.com/";
//   const databaseLink = "https://images.expertpowerhouse.com";
//   const [appointmentExist, setAppointmentExist] = useState(null);
//   const [eventType, setEventType] = useState(null);
//   const [lastContactLog, setLastContactLog] = useState([]);
//   const [openCall, setOpenCall] = useState(false);
//   const [inviteButtonName, setInviteButtonName] = useState("Invite");
//   const { API_URL, URI } = useContext(UrlContext);
//   const [defaultInviteTemplates, setDefaultInviteTemplates] = useState([]);
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [defaultEmailTemplates, setDefaultEmailTemplates] = useState([]);
//   const [loadingPopup, setLoadingPopup] = useState(false);
//   const [openEmail, setOpenEmail] = useState(false);
//   const [isInviteLoading, setIsInviteLoading] = useState(false);
//   const [isFollowLoading, setIsFollowLoading] = useState(false);
//   const [folloupEmail, setFolloupEmail] = useState(false);
//   const [defaultFollowupTemplates, setDefaultFollowupTemplates] = useState([]);
//   const [projectDeadline, setProjectDeadline] = useState("");
//   const [isModifyDeadline, setIsModifyDeadline] = useState(false);

//   // Save project invitation log on successfully sending the invitation
//   useEffect(() => {
//     if (isSuccess) {
//       sendProjectInvitation();
//     }
//   }, [isSuccess]);

//   const handleClickOnLogButton = () => {
//     setOpenCallDetails(true);
//   };
//   const handleClickOnNewButton = () => {
//     setEventType("new");
//     console.log("getting clicked!");
//     setIsCreateNewOpen(true);
//   };

//   useEffect(() => {
//     if (data.eventCreated === "yes") {
//       setAppointmentExist(true);
//     } else {
//       setAppointmentExist(false);
//     }
//     setNewStatus(data?.expertStatus);
//     setExContactedBy(data?.expert.contacted_by);
//     setExContactedMethod(data?.expert.mail_inmail);
//     setExDateCreated(data?.expert.Date_Created);
//     setExSavedBy(data?.expert.saved_by);
//     if (data?.expert.lastContactLog) {
//       setLastContactLog(data?.expert.lastContactLog[0]);
//     }
//     setVerified(data?.expert.verified);
//   }, [data]);

//   const updateProfileData = (exObject) => {
//     setExObject(exObject);
//   };
//   useEffect(() => {
//     if (data) {
//       setAvailablityDate(data.expert.Available_from);
//       setAvailabilityComment(data.expert.Available_comment);
//       setExObject({
//         expertName: data.expert.Name,
//         expertLink: data.expert.link,
//         expertEmail: data.expert.email,
//       });
//       setInviteName(data.expert.Name);
//       setNDAStatus(data.NDArequestStatus);
//       updateButtonName();
//     }
//   }, [data]);

//   useEffect(() => {
//     if (availablityDate) {
//       const today = new Date();
//       const availDate = new Date(availablityDate);
//       if (
//         availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" ||
//         availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT"
//       ) {
//         setAvailabiltyBorder("");
//       } else if (availDate < today) {
//         setAvailabiltyBorder("prjdetails-con-img-green");
//       } else if (availDate > today) {
//         setAvailabiltyBorder("prjdetails-con-img-red");
//       }
//     }
//   }, [availablityDate]);

//   if (hideDeletedRow) {
//     return null;
//   }

//   const updateButtonName = () => {
//     if (data.isSelfApplied) {
//       setInviteButtonName("Self applied");
//     } else if (data.hasDeclined) {
//       setInviteButtonName("Declined");
//     } else if (data.inviteStatus) {
//       setInviteButtonName("Submitted");
//     } else if (data.isInviteChecked) {
//       setInviteButtonName("Checked");
//     } else if (data.isInvited) {
//       setInviteButtonName("Invite sent");
//     }
//   };

//   // Function to log project invitation
//   const sendProjectInvitation = async () => {
//     const url = `${API_URL}send-project-invitation`;
//     await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         projectID: project_id,
//         expertID: data.expert.ID,
//       }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           setInviteButtonName("Invite sent");
//         } else {
//           console.error("Error saving invitation log:", data.msg);
//         }
//       });
//   };

//   // Function to get email template for sending email
//   const getEmailTemplate = async () => {
//     setLoadingPopup(true);
//     const tokenObj = localStorage.getItem("eph-token");
//     const token = JSON.parse(tokenObj).value;
//     const url = `${API_URL}get-email-template`;
//     await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({
//         projectID: project_id,
//         expertID: data.expert.ID,
//         projectName: project_name,
//         expertName: data.expert.Name,
//         expertEmail: data.expert.email,
//       }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           setDefaultEmailTemplates(data.templates);
//           setLoadingPopup(false);
//           setOpenEmail(true);
//         } else {
//           console.error("Error saving invitation log:", data.msg);
//           setLoadingPopup(false);
//         }
//       });
//   };

//   // Function to get invite template for sending email
//   const getInviteTemplate = async () => {
//     setIsInviteLoading(true);
//     const expertID = data.expert.ID;
//     const tokenObj = localStorage.getItem("eph-token");
//     const token = JSON.parse(tokenObj).value;
//     const url = `${API_URL}fetch-invite-templates-for-email`;
//     await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({
//         projectID: project_id,
//         expertID: expertID,
//         projectName: project_name,
//         expertName: data.expert.Name,
//         expertEmail: data.expert.email,
//       }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           const enrichedTemplates = data.templates.map((tpl) => ({
//             ...tpl,
//             linkedButton: getLinkedButton(tpl.lang, expertID),
//           }));
//           setDefaultInviteTemplates(enrichedTemplates);
//           setIsInviteLoading(false);
//           setInvitationRequest(true);
//         } else if (data.status === "deadline") {
//           setProjectDeadline(data.deadline);
//           setIsInviteLoading(false);
//           setIsModifyDeadline(true);
//         } else {
//           setIsInviteLoading(false);
//           Swal.fire("Error", data.text || "Invalid data!", "error");
//         }
//       });
//   };

//   // Helper function: return button markup depending on language
//   const getLinkedButton = (lang, expertID) => {
//     switch (lang) {
//       case "de":
//         return `
//           <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
//             <tr>
//               <td align="center">
//                 <!--[if mso]>
//                 <a href="https://consultant.expertpowerhouse.com/app/${expertID}" style="text-decoration:none;">
//                   <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
//                               xmlns:w="urn:schemas-microsoft-com:office:word"
//                               href="https://consultant.expertpowerhouse.com/app/${expertID}"
//                               style="height:40px;v-text-anchor:middle;width:280px;" arcsize="10%"
//                               stroke="f" fillcolor="#365561">
//                     <w:anchorlock/>
//                     <center>
//                       <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
//                         Opportunity ansehen
//                       </span>
//                     </center>
//                   </v:roundrect>
//                 </a>
//                 <![endif]-->
//                 <!--[if !mso]><!-- -->
//                 <table cellspacing="0" cellpadding="0" role="presentation">
//                   <tr>
//                     <td align="center" bgcolor="#365561" style="border-radius: 6px;">
//                       <a href="https://consultant.expertpowerhouse.com/app/${expertID}"
//                         target="_blank"
//                         style="
//                           font-size: 14px;
//                           font-family: Arial, sans-serif;
//                           color: #ffffff;
//                           text-decoration: none;
//                           padding: 12px 24px;
//                           display: inline-block;
//                           font-weight: bold;
//                         ">
//                         Opportunity ansehen
//                       </a>
//                     </td>
//                   </tr>
//                 </table>
//                 <!--<![endif]-->
//               </td>
//             </tr>
//           </table>
//         `;
//       default: // "en" or fallback
//         return `
//           <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
//             <tr>
//               <td align="center">
//                 <!--[if mso]>
//                 <a href="https://consultant.expertpowerhouse.com/app/${expertID}" style="text-decoration:none;">
//                   <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
//                               xmlns:w="urn:schemas-microsoft-com:office:word"
//                               href="https://consultant.expertpowerhouse.com/app/${expertID}"
//                               style="height:40px;v-text-anchor:middle;width:220px;" arcsize="10%"
//                               stroke="f" fillcolor="#365561">
//                     <w:anchorlock/>
//                     <center>
//                       <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
//                         See Opportunity
//                       </span>
//                     </center>
//                   </v:roundrect>
//                 </a>
//                 <![endif]-->
//                 <!--[if !mso]><!-- -->
//                 <table cellspacing="0" cellpadding="0" role="presentation">
//                   <tr>
//                     <td align="center" bgcolor="#365561" style="border-radius: 6px;">
//                       <a href="https://consultant.expertpowerhouse.com/app/${expertID}"
//                         target="_blank"
//                         style="
//                           font-size: 14px;
//                           font-family: Arial, sans-serif;
//                           color: #ffffff;
//                           text-decoration: none;
//                           padding: 12px 24px;
//                           display: inline-block;
//                           font-weight: bold;
//                         ">
//                         See Opportunity
//                       </a>
//                     </td>
//                   </tr>
//                 </table>
//                 <!--<![endif]-->
//               </td>
//             </tr>
//           </table>
//         `;
//     }
//   };

//   // Function to get followup template for sending email
//   const getFollowupTemplate = async () => {
//     setIsFollowLoading(true);
//     const expertID = data.expert.ID;
//     const tokenObj = localStorage.getItem("eph-token");
//     const token = JSON.parse(tokenObj).value;
//     const url = `${API_URL}fetch-followup-templates-for-email`;
//     await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({
//         projectID: project_id,
//         expertID: expertID,
//         projectName: project_name,
//         expertName: data.expert.Name,
//         expertEmail: data.expert.email,
//       }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.status === "success") {
//           setDefaultFollowupTemplates(data.templates);
//           setIsFollowLoading(false);
//           setFolloupEmail(true);
//         } else {
//           console.error("Error saving invitation log:", data.msg);
//           setIsFollowLoading(false);
//         }
//       });
//   };

//   return (
//     <div className="prjdetails-table-row">
//       {!fieldsLoading ? (
//         <>
//           <div className="prjdetails-row-top">
//             <input
//               className="single-checkbox"
//               type="checkbox"
//               checked={expertIDs.includes(data.expert.ID)}
//               onChange={(e) => {
//                 if (e.target.checked) {
//                   appendExpertId(data.expert.ID);
//                 } else {
//                   removeExpertId(data.expert.ID);
//                 }
//               }}
//             />
//             <div className="row-left-top-div">
//               <div className="con-image-div">
//                 <a
//                   href={`/app/ExpertDetails/${data.expert.ID}`}
//                   className="prjdetails-eph-profile"
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <img
//                     className={`prjdetails-con-img ${availabiltyBorder}`}
//                     // src={
//                     //   data.expert.profilePicture?.slice(0, 24) == mediaLink
//                     //     ? data.expert.profilePicture
//                     //     : `${databaseLink}${data.profilePicture}`
//                     // }
//                     src={
//                       data?.expert?.profilePicture?.includes(mediaLink)
//                         ? data?.expert?.profilePicture
//                         : `${databaseLink}${data?.expert?.profilePicture}`
//                     }
//                     alt=""
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = expertDefaultImg;
//                     }}
//                   />
//                 </a>
//                 <div className="name-con-expert-div">
//                   {/* <div className="expert-container"> */}
//                   <div style={{ display: "inline-flex" }}>
//                     <a
//                       className="prjdetails-con-name"
//                       href={exObject.expertLink}
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       {exObject.expertName}
//                     </a>
//                     <ProjectExpertIsVerified
//                       email={exObject.expertEmail}
//                       isVerified={verified}
//                       setIsVerified={setVerified}
//                       expert_id={data?.expert.ID}
//                       backupData={backupData}
//                       setBackupData={setBackupData}
//                     />
//                   </div>
//                   <div className="position-relative">
//                     <ProjectExpertType
//                       type={data?.expert.cons_exp}
//                       expert_id={data?.expert.ID}
//                       backupData={backupData}
//                       setBackupData={setBackupData}
//                     />
//                     <EditProfileBasic
//                       expert_id={data?.expert.ID}
//                       expert_Name={exObject.expertName}
//                       expert_link={exObject.expertLink}
//                       expert_email={exObject.expertEmail}
//                       updateProfileData={updateProfileData}
//                       backupData={backupData}
//                       setBackupData={setBackupData}
//                     />
//                   </div>
//                 </div>
//                 <ProjectExpertIsVip
//                   isVip={data?.expert.isVip}
//                   expert_id={data?.expert.ID}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                 />
//               </div>
//               <div className="left-bottom-phone position-relative">
//                 <i
//                   className="fa-regular fa-envelope"
//                   style={{ marginRight: "1px", fontSize: "16px" }}
//                 />
//                 <ExEmailChange
//                   key={data?.expert.ID}
//                   email={exObject.expertEmail}
//                   expert_id={data?.expert.ID}
//                   exObject={exObject}
//                   setExObject={setExObject}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                 />
//               </div>
//               <div className="left-bottom-phone position-relative">
//                 <i
//                   className="fa-solid fa-phone"
//                   style={{ marginRight: "2px" }}
//                 />
//                 <ExPhoneNumber
//                   key={data?.expert.ID}
//                   phone={data?.expert.phone_n}
//                   expert_id={data?.expert.ID}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                 />
//               </div>

//               <div className="left-bottom-hourly position-relative">
//                 <i className="fa-solid fa-money-bill-1" title="Hourly rate" />
//                 <ExHourlyRate
//                   key={data?.expert.ID}
//                   hourlyRate={data?.expert.hourly_rate}
//                   hourlyRateCurrency={data?.expert.hourly_rate_currency}
//                   expert_id={data?.expert.ID}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                 />
//               </div>
//               <div className="left-bottom-daily position-relative">
//                 <i className="fa-solid fa-money-bill" title="Daily rate" />
//                 <ExDailyRate
//                   key={data?.expert.ID}
//                   dailyRate={data?.expert.daily_rate}
//                   dailyRateCurrency={data?.expert.daily_rate_currency}
//                   expert_id={data?.expert.ID}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                 />{" "}
//               </div>
//               <p className="text-xs text-gray-400">
//                 {data?.expectedRate && `Expects: ${data?.expectedRate}`}
//               </p>
//             </div>
//             <div style={{ display: "inline-flex" }}>
//               <div className="prjdetails-panel prjdetails-third-panel">
//                 <div className="prjdetails-panel-body pn">
//                   <table className="table prjdetails-second-section mbn tc-icon-1 tc-med-2 tc-bold-last">
//                     <tbody>
//                       <tr>
//                         <td className="position-relative">
//                           <ExSummary
//                             key={data?.expert.ID}
//                             summary={
//                               data?.expert.summ?.trim()
//                                 ? data.expert.summ
//                                 : 'No Summary available'
//                             }
//                             expert_id={data?.expert.ID}
//                             summLength={summLength}
//                             setSummLength={setSummLength}
//                             showSummAlert={showSummAlert}
//                             setShowSummAlert={setShowSummAlert}
//                             backupData={backupData}
//                             setBackupData={setBackupData}
//                           />
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="position-relative">
//                           <ExExperience
//                             key={data?.expert.ID}
//                             experience={data?.expert.experience}
//                             expert_id={data?.expert.ID}
//                             backupData={backupData}
//                             setBackupData={setBackupData}
//                           />
//                         </td>
//                       </tr>
//                       <tr>
//                         <td className="position-relative">
//                           {data?.selfSummary?.length > 0 ? (
//                             <div
//                               dangerouslySetInnerHTML={{
//                                 __html: data?.selfSummary,
//                               }}
//                               className="project-expert-selfsummary"
//                             ></div>
//                           ) : (
//                             <ExShortProfile
//                               key={data?.expert.ID}
//                               shortProfile={data?.expert.eph_short}
//                               expert_id={data?.expert.ID}
//                               backupData={backupData}
//                               setBackupData={setBackupData}
//                             />
//                           )}
//                         </td>
//                       </tr>
//                       {partiallyAvailable && (
//                         <tr>
//                           <td className="position-relative">
//                             <ExMaxWorkingDays
//                               maxWork={data?.expert.max_working_days}
//                               expert_id={data?.expert.ID}
//                               backupData={backupData}
//                               setBackupData={setBackupData}
//                             />
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//             <div className="prjdetails-panel prjdetails-profile-status">
//               <div className="prjdetails-status-div">
//                 <ProjectExpertStatus
//                   status={data?.expertStatus}
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                   setPartiallyAvailable={setPartiallyAvailable}
//                   setNewStatus={setNewStatus}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                   setIsVerified={setVerified}
//                   tableData={tableData}
//                   setTableData={setTableData}
//                 />
//                 <SendNDA
//                   key={data?.expert.ID}
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                   NDAStatus={NDAStatus}
//                   setNDAStatus={setNDAStatus}
//                   in_zoho={data?.expert.in_zoho}
//                   data={data}
//                 />
//                 <ProjectScreeningQueAns
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                   screeningQuestions={screeningQuestions}
//                   data={data}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                 />
//                 {/* Invite button implementation */}
//                 <button
//                   className={`btn addToPjButton transition-opacity ${
//                     inviteButtonName !== "Invite"
//                       ? "opacity-50 cursor-default pointer-events-none"
//                       : "hover:opacity-90 cursor-pointer"
//                   }`}
//                   disabled={inviteButtonName !== "Invite"}
//                   onClick={() => {
//                     if (inviteButtonName === "Invite") {
//                       getInviteTemplate();
//                     }
//                   }}
//                 >
//                   {inviteButtonName}
//                 </button>
//                 {isInviteLoading && (
//                   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//                     <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="prjdetails-panel prjdetails-action-btn">
//               <div className="prjdetails-btns-div position-relative">
//                 <button
//                   className="btn"
//                   style={{ width: "130px" }}
//                   onClick={() => getEmailTemplate()}
//                 >
//                   <i
//                     className="fa-regular fa-envelope"
//                     title="Click to Email"
//                   />{" "}
//                   Email
//                 </button>
//                 {loadingPopup && (
//                   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//                     <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
//                   </div>
//                 )}
//                 {/* <SendEmail
//                   expert={data?.expert}
//                   project_id={project_id}
//                   project_name={project_name}
//                   exObject={exObject}
//                   setExContactedBy={setExContactedBy}
//                   setExContactedMethod={setExContactedMethod}
//                   setExDateCreated={setExDateCreated}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                   setEmailButtonClicked={setEmailButtonClicked}
//                   setSelectedConsulData={setSelectedConsulData}
//                   setEmailDetails={setEmailDetails}
//                   setComposeEmail={setComposeEmail}
//                   doRefresh={doRefresh}
//                   setDoRefresh={setDoRefresh}
//                   currentExpertID={currentExpertID}
//                   setCurrentExpertID={setCurrentExpertID}
//                 /> */}
//                 <button
//                   className="btn"
//                   style={{ width: "130px" }}
//                   onClick={() => getFollowupTemplate()}
//                 >
//                   <i className="fa fa-envelope" title="Click to Email" />{" "}
//                   Follow-Up
//                 </button>
//                 {isFollowLoading && (
//                   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
//                     <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
//                   </div>
//                 )}
//                 {/* <SendFollowUpEmail
//                   expert={data?.expert}
//                   project_id={project_id}
//                   project_name={project_name}
//                   exObject={exObject}
//                   setExContactedBy={setExContactedBy}
//                   setExContactedMethod={setExContactedMethod}
//                   setExDateCreated={setExDateCreated}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                   setEmailButtonClicked={setEmailButtonClicked}
//                   setSelectedConsulData={setSelectedConsulData}
//                   setEmailDetails={setEmailDetails}
//                   setComposeEmail={setComposeEmail}
//                   setCurrentExpertID={setCurrentExpertID}
//                   doRefresh={doRefresh}
//                   setDoRefresh={setDoRefresh}
//                 /> */}
//                 <LogInmail
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                   setExContactedBy={setExContactedBy}
//                   setExContactedMethod={setExContactedMethod}
//                   setExDateCreated={setExDateCreated}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                   doRefresh={doRefresh}
//                   setDoRefresh={setDoRefresh}
//                   currentExpertID={currentExpertID}
//                   setCurrentExpertID={setCurrentExpertID}
//                   profileURL={exObject.expertLink}
//                 />
//                 <LogCalls
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                   setExContactedBy={setExContactedBy}
//                   setExContactedMethod={setExContactedMethod}
//                   setExDateCreated={setExDateCreated}
//                   backupData={backupData}
//                   setBackupData={setBackupData}
//                   doRefresh={doRefresh}
//                   setDoRefresh={setDoRefresh}
//                   currentExpertID={currentExpertID}
//                   setCurrentExpertID={setCurrentExpertID}
//                 />
//                 {/* <SendUndo expert_id={data?.expert.ID} project_id={project_id} /> */}
//                 {/* <ConnectionBtn
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                 /> */}
//               </div>
//             </div>

//             <div className="prjdetails-panel prjdetails-action-btn">
//               <div className="prjdetails-btns-div position-relative">
//                 <ExZohoBtn
//                   expert_id={data?.expert.ID}
//                   in_zoho={data?.expert.in_zoho}
//                   status={newStatus}
//                   summLength={summLength}
//                   setShowSummAlert={setShowSummAlert}
//                   exObject={exObject}
//                   project_id={project_id}
//                 />
//                 <ExCreateDigitalPPT
//                   digitalExist={data?.digitalExist}
//                   expert_id={data?.expert.ID}
//                   project_id={project_id}
//                 />

//                 <Link
//                   to={`/app/SimilarProfiles/${project_id}/${data.expert.ID}`}
//                 >
//                   <button className="btn">
//                     <i className="fa-solid fa-users-viewfinder" /> Similar
//                     Profiles
//                   </button>
//                 </Link>
//                 <AddToProject
//                   expertID={data.expert.ID}
//                   btnName={" Add to project"}
//                 />
//               </div>
//             </div>
//           </div>{" "}
//         </>
//       ) : (
//         <div className="prjdetails-row-top" style={{ height: "250px" }}></div>
//       )}
//       <div className="prjdetails-row-bottom">
//         <div
//           style={{
//             float: "left",
//             marginLeft: "11px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {showComment && (
//             <ExAvailabilityComment
//               key={data?.expert.ID}
//               comment={availabilityComment}
//               expert_id={data?.expert.ID}
//               setAvailabilityComment={setAvailabilityComment}
//               backupData={backupData}
//               setBackupData={setBackupData}
//               setShowComment={setShowComment}
//             />
//           )}
//           <div
//             className="topCon-available-date"
//             style={{ marginRight: "15px" }}
//           >
//             <i
//               className="calender-icon fa-regular fa-calendar-days"
//               style={{ marginRight: "11px" }}
//             ></i>
//             <label>Availability</label>
//             <div className="inline-block group">
//               <i
//                 className={
//                   availabilityComment
//                     ? "comment-icon fa-solid fa-comment-dots"
//                     : "comment-icon comment-empty fa-regular fa-comment-dots"
//                 }
//                 onClick={() => setShowComment(!showComment)}
//                 style={{
//                   left: "98px",
//                   color: availabilityComment ? "#365561" : "grey",
//                   cursor: "pointer",
//                 }}
//               ></i>

//               {availabilityComment && (
//                 <div className="absolute left-[150px] -translate-x-1/2 top-10 w-max max-w-xs bg-[#365561] text-white text-sm px-3 py-1 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none">
//                   {availabilityComment}
//                 </div>
//               )}
//             </div>
//             <ExAvailabilityDate
//               key={data?.expert.ID}
//               date={data?.expert.Available_from}
//               expertID={data?.expert.ID}
//               setAvailablityDate={setAvailablityDate}
//               backupData={backupData}
//               setBackupData={setBackupData}
//             />
//           </div>

//           {appointmentExist ? (
//             <>
//               <div className="call-setup-div">
//                 <button
//                   type="button"
//                   className="call-setup-btn tooltip-shareProfile"
//                   onClick={() => setOpenCall(true)}
//                   style={{ backgroundColor: "#f9f9f9" }}
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     x="0px"
//                     y="0px"
//                     width="23"
//                     height="23"
//                     viewBox="0 0 55 55"
//                     fill="currentcolor"
//                   >
//                     <path d="M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z"></path>
//                   </svg>
//                   <span className="tooltip-text">View Calls</span>
//                 </button>
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="call-setup-div">
//                 <button
//                   type="button"
//                   className="call-setup-btn tooltip-shareProfile"
//                   onClick={() => setOpenCall(true)}
//                   style={{ backgroundColor: "#f9f9f9" }}
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     x="0px"
//                     y="0px"
//                     width="23"
//                     height="23"
//                     viewBox="0 0 55 55"
//                     fill="currentcolor"
//                   >
//                     <path d="M 27 4 C 23.145666 4 20 7.1456661 20 11 C 20 11.694215 20.109343 12.364062 20.298828 13 L 5 13 C 3.3550302 13 2 14.35503 2 16 L 2 34 C 2 35.64497 3.3550302 37 5 37 L 16.050781 37 C 16.558532 42.596375 21.274041 47 27 47 C 32.119276 47 36.240954 43.409081 37.460938 38.664062 C 38.643436 39.440841 39.984387 40 41.5 40 C 45.63039 40 49 36.63039 49 32.5 L 49 21 A 1.0001 1.0001 0 0 0 48 20 L 37 20 L 26 20 L 26 17.923828 C 26.327632 17.970927 26.660365 18 27 18 C 30.854334 18 34 14.854334 34 11 C 34 7.1456661 30.854334 4 27 4 z M 27 6 C 29.773666 6 32 8.2263339 32 11 C 32 13.773666 29.773666 16 27 16 C 26.651336 16 26.315457 15.955685 25.988281 15.888672 C 25.927569 14.29544 24.606899 13 23 13 L 22.421875 13 C 22.153458 12.388243 22 11.715897 22 11 C 22 8.2263339 24.226334 6 27 6 z M 42 8 C 40.416667 8 39.101892 8.6297556 38.251953 9.5859375 C 37.402014 10.542119 37 11.777778 37 13 C 37 14.222222 37.402014 15.457881 38.251953 16.414062 C 39.101892 17.370244 40.416667 18 42 18 C 43.583333 18 44.898108 17.370244 45.748047 16.414062 C 46.597986 15.457881 47 14.222222 47 13 C 47 11.777778 46.597986 10.542119 45.748047 9.5859375 C 44.898108 8.6297556 43.583333 8 42 8 z M 42 10 C 43.083333 10 43.768559 10.370244 44.251953 10.914062 C 44.735347 11.457882 45 12.222222 45 13 C 45 13.777778 44.735347 14.542119 44.251953 15.085938 C 43.768559 15.629755 43.083333 16 42 16 C 40.916667 16 40.231441 15.629756 39.748047 15.085938 C 39.264653 14.542118 39 13.777778 39 13 C 39 12.222222 39.264653 11.457881 39.748047 10.914062 C 40.231441 10.370245 40.916667 10 42 10 z M 5 15 L 21.757812 15 L 23 15 C 23.56503 15 24 15.43497 24 16 L 24 16.365234 A 1.0001 1.0001 0 0 0 24 16.919922 L 24 20.832031 A 1.0001 1.0001 0 0 0 24 21.158203 L 24 34 C 24 34.56503 23.56503 35 23 35 L 17.167969 35 A 1.0001 1.0001 0 0 0 16.841797 35 L 5 35 C 4.4349698 35 4 34.56503 4 34 L 4 16 C 4 15.43497 4.4349698 15 5 15 z M 9 19 L 9 21 L 13 21 L 13 31 L 15 31 L 15 21 L 19 21 L 19 19 L 9 19 z M 26 22 L 36 22 L 36 36 C 36 40.982593 31.982593 45 27 45 C 22.356014 45 18.554378 41.508579 18.058594 37 L 23 37 C 24.64497 37 26 35.64497 26 34 L 26 22 z M 38 22 L 47 22 L 47 32.5 C 47 35.54961 44.54961 38 41.5 38 C 40.097088 38 38.851397 37.45098 37.880859 36.591797 C 37.89251 36.384961 38 36.209688 38 36 L 38 22 z"></path>
//                   </svg>
//                   <span className="tooltip-text">Setup Calls</span>
//                 </button>
//               </div>
//               {/* {invitationRequest ? (
//                 <InviteToProject
//                   key={data?.expert.ID}
//                   projectID={project_id}
//                   projectType={projectType}
//                   inviteName={inviteName}
//                   data={data}
//                   onClose={() => setInvitationRequest(false)}
//                   onSend={console.log("send")}
//                   project_name={project_name}
//                   setInviteButtonName={setInviteButtonName}
//                 />
//               ) : null} */}
//             </>
//           )}

//           <div style={{ marginLeft: "15px" }}>
//             {data.recordConsent === null ? (
//               <span>Didn't give record consent yet</span>
//             ) : data.recordConsent === false ? (
//               <span style={{ color: "red" }}>
//                 Does not agree to being recorded
//               </span>
//             ) : (
//               <span style={{ color: "green" }}>Agrees to being recorded</span>
//             )}
//           </div>
//         </div>
//         <div>
//           {/* Bappi: are we using it? */}
//           {availability?.length > 0 ? (
//             <span
//               onClick={() => {
//                 setAvailabilityPopup(true);
//               }}
//             >
//               Check availability for a call
//             </span>
//           ) : null}
//         </div>
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <ExContactedDate
//             key={data?.expert.ID}
//             data={data}
//             doRefresh={doRefresh}
//             setDoRefresh={setDoRefresh}
//             currentExpertID={currentExpertID}
//             setCurrentExpertID={setCurrentExpertID}
//           />
//           <ExAddedDate
//             // key={data?.expert.ID}
//             addedTime={data?.expertAdded}
//             addedBy={data?.expertAddedBy}
//           />
//           <ProjectExpertDelete
//             // key={data?.expert.ID}
//             expert_id={data?.expert.ID}
//             project_id={project_id}
//             setHideDeletedRow={setHideDeletedRow}
//             tableData={tableData}
//             setTableData={setTableData}
//             backupData={backupData}
//             setBackupData={setBackupData}
//           />
//         </div>
//       </div>
//       {availabilityPopup ? (
//         <div className="appointment-wrapper">
//           <AvailabilityCalendar
//             availability={availability}
//             setAvailability={setAvailability}
//             setAvailabilityForm={setAvailabilityPopup}
//           />
//         </div>
//       ) : null}
//       {openCall && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
//           {/* <AppointmentScheduler
//             projectID={project_id}
//             expertID={data.expert.ID}
//             setAppointmentExist={setAppointmentExist}
//             openCall={openCall}
//             setOpenCall={setOpenCall}
//           /> */}
//           <EphCalendar 
//             projectID={project_id}
//             expertID={data.expert.ID}
//             setOpenCall={setOpenCall}
//             setAppointmentExist={setAppointmentExist}
//           />
//         </div>
//       )}
//       {invitationRequest && (
//         <ComposeNewEmail
//           onClose={() => setInvitationRequest(false)}
//           defaultTo={[data?.expert?.email]}
//           defaultTemplates={defaultInviteTemplates}
//           setSuccess={setIsSuccess}
//           callingFrom={'Invite'}
//           projectID={project_id}
//         />
//       )}
//       {openEmail && (
//         <ComposeNewEmail
//           onClose={() => setOpenEmail(false)}
//           defaultTo={[data?.expert.email]}
//           defaultTemplates={defaultEmailTemplates}
//           callingFrom={'Email'}
//           projectID={project_id}
//         />
//       )}
//       {folloupEmail && (
//         <ComposeNewEmail
//           onClose={() => setFolloupEmail(false)}
//           defaultTo={[data?.expert?.email]}
//           defaultTemplates={defaultFollowupTemplates}
//           callingFrom={'FollowUp'}
//           projectID={project_id}
//         />
//       )}

//       {isModifyDeadline && (
//         <ModifyProjectDeadline
//           projectID={project_id}
//           projectDeadline={projectDeadline}
//           setIsModifyDeadline={setIsModifyDeadline}
//         />
//       )}
//     </div>
//   );
// }




// New prototype for drag & drop CVs to fetch contact info
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import expertDefaultImg from "../../images/expert-default.png";
import SendInmail from "./SendInmail";
import SendEmail from "./SendEmail";
import SendFollowUpEmail from "./SendFollowUpEmail";
import EditProfileBasic from "./EditProfileBasic";
import ExAvailabilityComment from "./ExAvailabilityComment";
import ExExperience from "./ExExperience";
import ExHourlyRate from "./ExHourlyRate";
import ExDailyRate from "./ExDailyRate";
import ExPhoneNumber from "./ExPhoneNumber";
import ProjectExpertStatus from "./ProjectExpertStatus";
import ProjectExpertType from "./ProjectExpertType";
import ExShortProfile from "./ExShortProfile";
import ProjectExpertIsVip from "./ProjectExpertIsVip";
import ExZohoBtn from "./ExZohoBtn";
import ExMaxWorkingDays from "./ExMaxWorkingDays";
import ProjectExpertDelete from "./ProjectExpertDelete";
import ExSummary from "./ExSummary";
import ExContactedDate from "./ExContactedDate";
import ExCreateDigitalPPT from "./ExCreateDigitalPPT";
import ExAddedDate from "./ExAddedDate";
import ExAvailabilityDate from "./ExAvailabilityDate";
import LogInmail from "./LogInmail";
import LogCalls from "./LogCalls";
import SendNDA from "./SendNDA";
import ConnectionBtn from "./ConnectionBtn";
import ExEmailChange from "./ExEmailChange";
import AppointmentScheduler from "./AppointmentCreator";
import AddToProject from "../ExpertDetails/AddToProject";
import ProjectScreeningQueAns from "./ProjectScreeningQueAns";
import { UserContext } from "../../contexts/UserContext";
import { UrlContext } from "../../contexts/UrlContext";
import Swal from "sweetalert2";
import loadingIcon from "../../images/Loading_icon.gif";
import AvailabilityCalendar from "../ConsultantProjects/AvailabilityCalendar";
import InviteToProject from "./InviteToProject";
import ProjectExpertIsVerified from "./ProjectExpertIsVerified";
import { use } from "react";
import ComposeNewEmail from "../../components/EmailUI/ComposeNewEmail";
import { get } from "jquery";
import { de } from "date-fns/locale";
import ModifyProjectDeadline from "./ModifyDeadline";
import EphCalendar from "../../components/ProjectDetails/EphCalendar";
import CvContactPreviewModal from "./CvContactPreviewModal";

export default function ProjectExpertRow({
  data,
  project_id,
  appendExpertId,
  removeExpertId,
  project_name,
  backupData,
  setBackupData,
  setEmailButtonClicked,
  setSelectedConsulData,
  setEmailDetails,
  setComposeEmail,
  fieldsLoading,
  screeningQuestions,
  projectType,
  expertIDs,
  tableData,
  setTableData,
  doRefresh,
  setDoRefresh,
  currentExpertID,
  setCurrentExpertID,
  username,
}) {
  const [hideDeletedRow, setHideDeletedRow] = useState(false);
  // Preview-only drop handling: no persistence or profile update.
  const [cvDropActive, setCvDropActive] = useState(false);
  const [cvPreviewFile, setCvPreviewFile] = useState(null);
  const dragDepth = useRef(0);
  const handleCvDragEnter = (event) => {
    if (!event.dataTransfer?.types?.includes("Files")) return;
    event.preventDefault();
    dragDepth.current += 1;
    setCvDropActive(true);
  };
  const handleCvDragOver = (event) => {
    if (!event.dataTransfer?.types?.includes("Files")) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
    setCvDropActive(true);
  };
  const handleCvDragLeave = (event) => {
    event.preventDefault();
    dragDepth.current = Math.max(0, dragDepth.current - 1);
    if (!dragDepth.current) setCvDropActive(false);
  };
  const handleCvDrop = (event) => {
    event.preventDefault(); event.stopPropagation();
    dragDepth.current = 0; setCvDropActive(false);
    const files = Array.from(event.dataTransfer?.files || []);
    if (files.length !== 1 || !(files[0].type === "application/pdf" || /\.pdf$/i.test(files[0].name))) {
      Swal.fire("PDF required", "Drop exactly one PDF onto a consultant row.", "warning");
      return;
    }
    setCvPreviewFile(files[0]);
  };
  const [exObject, setExObject] = useState({
    expertName: "",
    expertLink: "",
    expertEmail: "",
  });
  const [isCreateNewOpen, setIsCreateNewOpen] = useState(false);
  const [openCallDetails, setOpenCallDetails] = useState(false);
  const [partiallyAvailable, setPartiallyAvailable] = useState(false);
  const [availablityDate, setAvailablityDate] = useState(null);
  const [availabiltyBorder, setAvailabiltyBorder] = useState("");
  const [NDAStatus, setNDAStatus] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [summLength, setSummLength] = useState(0);
  const [showSummAlert, setShowSummAlert] = useState(false);
  const [availabilityComment, setAvailabilityComment] = useState(null);
  const [showComment, setShowComment] = useState(false);
  const [exContactedBy, setExContactedBy] = useState(null);
  const [exContactedMethod, setExContactedMethod] = useState(null);
  const [exDateCreated, setExDateCreated] = useState(null);
  const [exSavedBy, setExSavedBy] = useState(null);
  const [verified, setVerified] = useState(true);

  const [availabilityPopup, setAvailabilityPopup] = useState(false);
  const [availability, setAvailability] = useState([]);
  const [invitationRequest, setInvitationRequest] = useState(false);
  const [loadingInvitation, setLoadingInvitation] = useState(false);
  const [inviteName, setInviteName] = useState("");
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [appointmentExist, setAppointmentExist] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [lastContactLog, setLastContactLog] = useState([]);
  const [openCall, setOpenCall] = useState(false);
  const [inviteButtonName, setInviteButtonName] = useState("Invite");
  const { API_URL, URI } = useContext(UrlContext);
  const [defaultInviteTemplates, setDefaultInviteTemplates] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [defaultEmailTemplates, setDefaultEmailTemplates] = useState([]);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [isInviteLoading, setIsInviteLoading] = useState(false);
  const [isFollowLoading, setIsFollowLoading] = useState(false);
  const [folloupEmail, setFolloupEmail] = useState(false);
  const [defaultFollowupTemplates, setDefaultFollowupTemplates] = useState([]);
  const [projectDeadline, setProjectDeadline] = useState("");
  const [isModifyDeadline, setIsModifyDeadline] = useState(false);

  // Save project invitation log on successfully sending the invitation
  useEffect(() => {
    if (isSuccess) {
      sendProjectInvitation();
    }
  }, [isSuccess]);

  const handleClickOnLogButton = () => {
    setOpenCallDetails(true);
  };
  const handleClickOnNewButton = () => {
    setEventType("new");
    console.log("getting clicked!");
    setIsCreateNewOpen(true);
  };

  useEffect(() => {
    if (data.eventCreated === "yes") {
      setAppointmentExist(true);
    } else {
      setAppointmentExist(false);
    }
    setNewStatus(data?.expertStatus);
    setExContactedBy(data?.expert.contacted_by);
    setExContactedMethod(data?.expert.mail_inmail);
    setExDateCreated(data?.expert.Date_Created);
    setExSavedBy(data?.expert.saved_by);
    if (data?.expert.lastContactLog) {
      setLastContactLog(data?.expert.lastContactLog[0]);
    }
    setVerified(data?.expert.verified);
  }, [data]);

  const updateProfileData = (exObject) => {
    setExObject(exObject);
  };
  useEffect(() => {
    if (data) {
      setAvailablityDate(data.expert.Available_from);
      setAvailabilityComment(data.expert.Available_comment);
      setExObject({
        expertName: data.expert.Name,
        expertLink: data.expert.link,
        expertEmail: data.expert.email,
      });
      setInviteName(data.expert.Name);
      setNDAStatus(data.NDArequestStatus);
      updateButtonName();
    }
  }, [data]);

  useEffect(() => {
    if (availablityDate) {
      const today = new Date();
      const availDate = new Date(availablityDate);
      if (
        availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" ||
        availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT"
      ) {
        setAvailabiltyBorder("");
      } else if (availDate < today) {
        setAvailabiltyBorder("prjdetails-con-img-green");
      } else if (availDate > today) {
        setAvailabiltyBorder("prjdetails-con-img-red");
      }
    }
  }, [availablityDate]);

  if (hideDeletedRow) {
    return null;
  }

  const updateButtonName = () => {
    if (data.isSelfApplied) {
      setInviteButtonName("Self applied");
    } else if (data.hasDeclined) {
      setInviteButtonName("Declined");
    } else if (data.inviteStatus) {
      setInviteButtonName("Submitted");
    } else if (data.isInviteChecked) {
      setInviteButtonName("Checked");
    } else if (data.isInvited) {
      setInviteButtonName("Invite sent");
    }
  };

  // Function to log project invitation
  const sendProjectInvitation = async () => {
    const url = `${API_URL}send-project-invitation`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        projectID: project_id,
        expertID: data.expert.ID,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setInviteButtonName("Invite sent");
        } else {
          console.error("Error saving invitation log:", data.msg);
        }
      });
  };

  // Function to get email template for sending email
  const getEmailTemplate = async () => {
    setLoadingPopup(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}get-email-template`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        projectID: project_id,
        expertID: data.expert.ID,
        projectName: project_name,
        expertName: data.expert.Name,
        expertEmail: data.expert.email,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setDefaultEmailTemplates(data.templates);
          setLoadingPopup(false);
          setOpenEmail(true);
        } else {
          console.error("Error saving invitation log:", data.msg);
          setLoadingPopup(false);
        }
      });
  };

  // Function to get invite template for sending email
  const getInviteTemplate = async () => {
    setIsInviteLoading(true);
    const expertID = data.expert.ID;
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}fetch-invite-templates-for-email`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        projectID: project_id,
        expertID: expertID,
        projectName: project_name,
        expertName: data.expert.Name,
        expertEmail: data.expert.email,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const enrichedTemplates = data.templates.map((tpl) => ({
            ...tpl,
            linkedButton: getLinkedButton(tpl.lang, expertID),
          }));
          setDefaultInviteTemplates(enrichedTemplates);
          setIsInviteLoading(false);
          setInvitationRequest(true);
        } else if (data.status === "deadline") {
          setProjectDeadline(data.deadline);
          setIsInviteLoading(false);
          setIsModifyDeadline(true);
        } else {
          setIsInviteLoading(false);
          Swal.fire("Error", data.text || "Invalid data!", "error");
        }
      });
  };

  // Helper function: return button markup depending on language
  const getLinkedButton = (lang, expertID) => {
    switch (lang) {
      case "de":
        return `
          <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
            <tr>
              <td align="center">
                <!--[if mso]>
                <a href="https://consultant.expertpowerhouse.com/app/${expertID}" style="text-decoration:none;">
                  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                              xmlns:w="urn:schemas-microsoft-com:office:word"
                              href="https://consultant.expertpowerhouse.com/app/${expertID}"
                              style="height:40px;v-text-anchor:middle;width:280px;" arcsize="10%"
                              stroke="f" fillcolor="#365561">
                    <w:anchorlock/>
                    <center>
                      <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                        Opportunity ansehen
                      </span>
                    </center>
                  </v:roundrect>
                </a>
                <![endif]-->
                <!--[if !mso]><!-- -->
                <table cellspacing="0" cellpadding="0" role="presentation">
                  <tr>
                    <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                      <a href="https://consultant.expertpowerhouse.com/app/${expertID}"
                        target="_blank"
                        style="
                          font-size: 14px;
                          font-family: Arial, sans-serif;
                          color: #ffffff;
                          text-decoration: none;
                          padding: 12px 24px;
                          display: inline-block;
                          font-weight: bold;
                        ">
                        Opportunity ansehen
                      </a>
                    </td>
                  </tr>
                </table>
                <!--<![endif]-->
              </td>
            </tr>
          </table>
        `;
      default: // "en" or fallback
        return `
          <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
            <tr>
              <td align="center">
                <!--[if mso]>
                <a href="https://consultant.expertpowerhouse.com/app/${expertID}" style="text-decoration:none;">
                  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                              xmlns:w="urn:schemas-microsoft-com:office:word"
                              href="https://consultant.expertpowerhouse.com/app/${expertID}"
                              style="height:40px;v-text-anchor:middle;width:220px;" arcsize="10%"
                              stroke="f" fillcolor="#365561">
                    <w:anchorlock/>
                    <center>
                      <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                        See Opportunity
                      </span>
                    </center>
                  </v:roundrect>
                </a>
                <![endif]-->
                <!--[if !mso]><!-- -->
                <table cellspacing="0" cellpadding="0" role="presentation">
                  <tr>
                    <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                      <a href="https://consultant.expertpowerhouse.com/app/${expertID}"
                        target="_blank"
                        style="
                          font-size: 14px;
                          font-family: Arial, sans-serif;
                          color: #ffffff;
                          text-decoration: none;
                          padding: 12px 24px;
                          display: inline-block;
                          font-weight: bold;
                        ">
                        See Opportunity
                      </a>
                    </td>
                  </tr>
                </table>
                <!--<![endif]-->
              </td>
            </tr>
          </table>
        `;
    }
  };

  // Function to get followup template for sending email
  const getFollowupTemplate = async () => {
    setIsFollowLoading(true);
    const expertID = data.expert.ID;
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}fetch-followup-templates-for-email`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        projectID: project_id,
        expertID: expertID,
        projectName: project_name,
        expertName: data.expert.Name,
        expertEmail: data.expert.email,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setDefaultFollowupTemplates(data.templates);
          setIsFollowLoading(false);
          setFolloupEmail(true);
        } else {
          console.error("Error saving invitation log:", data.msg);
          setIsFollowLoading(false);
        }
      });
  };

  return (
    <div className={`prjdetails-table-row relative ${cvDropActive ? "ring-2 ring-[#365561] ring-offset-2 bg-[#365561]/[0.06]" : ""}`}
      onDragEnter={handleCvDragEnter} onDragOver={handleCvDragOver} onDragLeave={handleCvDragLeave} onDrop={handleCvDrop}> 
      {cvDropActive && <div className="pointer-events-none absolute inset-0 z-[30] flex items-center justify-center rounded-xl border-2 border-dashed border-[#365561] bg-white/80 text-sm font-bold text-[#365561]">Drop PDF to preview CV contacts for {data?.expert?.Name}</div>}
      {!fieldsLoading ? (
        <>
          <div className="prjdetails-row-top">
            <input
              className="single-checkbox"
              type="checkbox"
              checked={expertIDs.includes(data.expert.ID)}
              onChange={(e) => {
                if (e.target.checked) {
                  appendExpertId(data.expert.ID);
                } else {
                  removeExpertId(data.expert.ID);
                }
              }}
            />
            <div className="row-left-top-div">
              <div className="con-image-div">
                <a
                  href={`/app/ExpertDetails/${data.expert.ID}`}
                  className="prjdetails-eph-profile"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className={`prjdetails-con-img ${availabiltyBorder}`}
                    // src={
                    //   data.expert.profilePicture?.slice(0, 24) == mediaLink
                    //     ? data.expert.profilePicture
                    //     : `${databaseLink}${data.profilePicture}`
                    // }
                    src={
                      data?.expert?.profilePicture?.includes(mediaLink)
                        ? data?.expert?.profilePicture
                        : `${databaseLink}${data?.expert?.profilePicture}`
                    }
                    alt=""
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = expertDefaultImg;
                    }}
                  />
                </a>
                <div className="name-con-expert-div">
                  {/* <div className="expert-container"> */}
                  <div style={{ display: "inline-flex" }}>
                    <a
                      className="prjdetails-con-name"
                      href={exObject.expertLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {exObject.expertName}
                    </a>
                    <ProjectExpertIsVerified
                      email={exObject.expertEmail}
                      isVerified={verified}
                      setIsVerified={setVerified}
                      expert_id={data?.expert.ID}
                      backupData={backupData}
                      setBackupData={setBackupData}
                    />
                  </div>
                  <div className="position-relative">
                    <ProjectExpertType
                      type={data?.expert.cons_exp}
                      expert_id={data?.expert.ID}
                      backupData={backupData}
                      setBackupData={setBackupData}
                    />
                    <EditProfileBasic
                      expert_id={data?.expert.ID}
                      expert_Name={exObject.expertName}
                      expert_link={exObject.expertLink}
                      expert_email={exObject.expertEmail}
                      updateProfileData={updateProfileData}
                      backupData={backupData}
                      setBackupData={setBackupData}
                    />
                  </div>
                </div>
                <ProjectExpertIsVip
                  isVip={data?.expert.isVip}
                  expert_id={data?.expert.ID}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />
              </div>
              <div className="left-bottom-phone position-relative">
                <i
                  className="fa-regular fa-envelope"
                  style={{ marginRight: "1px", fontSize: "16px" }}
                />
                <ExEmailChange
                  key={data?.expert.ID}
                  email={exObject.expertEmail}
                  expert_id={data?.expert.ID}
                  exObject={exObject}
                  setExObject={setExObject}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />
              </div>
              <div className="left-bottom-phone position-relative">
                <i
                  className="fa-solid fa-phone"
                  style={{ marginRight: "2px" }}
                />
                <ExPhoneNumber
                  key={data?.expert.ID}
                  phone={data?.expert.phone_n}
                  expert_id={data?.expert.ID}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />
              </div>

              <div className="left-bottom-hourly position-relative">
                <i className="fa-solid fa-money-bill-1" title="Hourly rate" />
                <ExHourlyRate
                  key={data?.expert.ID}
                  hourlyRate={data?.expert.hourly_rate}
                  hourlyRateCurrency={data?.expert.hourly_rate_currency}
                  expert_id={data?.expert.ID}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />
              </div>
              <div className="left-bottom-daily position-relative">
                <i className="fa-solid fa-money-bill" title="Daily rate" />
                <ExDailyRate
                  key={data?.expert.ID}
                  dailyRate={data?.expert.daily_rate}
                  dailyRateCurrency={data?.expert.daily_rate_currency}
                  expert_id={data?.expert.ID}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />{" "}
              </div>
              <p className="text-xs text-gray-400">
                {data?.expectedRate && `Expects: ${data?.expectedRate}`}
              </p>
            </div>
            <div style={{ display: "inline-flex" }}>
              <div className="prjdetails-panel prjdetails-third-panel">
                <div className="prjdetails-panel-body pn">
                  <table className="table prjdetails-second-section mbn tc-icon-1 tc-med-2 tc-bold-last">
                    <tbody>
                      <tr>
                        <td className="position-relative">
                          <ExSummary
                            key={data?.expert.ID}
                            summary={
                              data?.expert.summ?.trim()
                                ? data.expert.summ
                                : 'No Summary available'
                            }
                            expert_id={data?.expert.ID}
                            summLength={summLength}
                            setSummLength={setSummLength}
                            showSummAlert={showSummAlert}
                            setShowSummAlert={setShowSummAlert}
                            backupData={backupData}
                            setBackupData={setBackupData}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="position-relative">
                          <ExExperience
                            key={data?.expert.ID}
                            experience={data?.expert.experience}
                            expert_id={data?.expert.ID}
                            backupData={backupData}
                            setBackupData={setBackupData}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="position-relative">
                          {data?.selfSummary?.length > 0 ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: data?.selfSummary,
                              }}
                              className="project-expert-selfsummary"
                            ></div>
                          ) : (
                            <ExShortProfile
                              key={data?.expert.ID}
                              shortProfile={data?.expert.eph_short}
                              expert_id={data?.expert.ID}
                              backupData={backupData}
                              setBackupData={setBackupData}
                            />
                          )}
                        </td>
                      </tr>
                      {partiallyAvailable && (
                        <tr>
                          <td className="position-relative">
                            <ExMaxWorkingDays
                              maxWork={data?.expert.max_working_days}
                              expert_id={data?.expert.ID}
                              backupData={backupData}
                              setBackupData={setBackupData}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="prjdetails-panel prjdetails-profile-status">
              <div className="prjdetails-status-div">
                <ProjectExpertStatus
                  status={data?.expertStatus}
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  setPartiallyAvailable={setPartiallyAvailable}
                  setNewStatus={setNewStatus}
                  backupData={backupData}
                  setBackupData={setBackupData}
                  setIsVerified={setVerified}
                  tableData={tableData}
                  setTableData={setTableData}
                />
                <SendNDA
                  key={data?.expert.ID}
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  NDAStatus={NDAStatus}
                  setNDAStatus={setNDAStatus}
                  in_zoho={data?.expert.in_zoho}
                  data={data}
                />
                <ProjectScreeningQueAns
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  screeningQuestions={screeningQuestions}
                  data={data}
                  backupData={backupData}
                  setBackupData={setBackupData}
                />
                {/* Invite button implementation */}
                <button
                  className={`btn addToPjButton transition-opacity ${
                    inviteButtonName !== "Invite"
                      ? "opacity-50 cursor-default pointer-events-none"
                      : "hover:opacity-90 cursor-pointer"
                  }`}
                  disabled={inviteButtonName !== "Invite"}
                  onClick={() => {
                    if (inviteButtonName === "Invite") {
                      getInviteTemplate();
                    }
                  }}
                >
                  {inviteButtonName}
                </button>
                {isInviteLoading && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
                  </div>
                )}
              </div>
            </div>

            <div className="prjdetails-panel prjdetails-action-btn">
              <div className="prjdetails-btns-div position-relative">
                <button
                  className="btn"
                  style={{ width: "130px" }}
                  onClick={() => getEmailTemplate()}
                >
                  <i
                    className="fa-regular fa-envelope"
                    title="Click to Email"
                  />{" "}
                  Email
                </button>
                {loadingPopup && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
                  </div>
                )}
                {/* <SendEmail
                  expert={data?.expert}
                  project_id={project_id}
                  project_name={project_name}
                  exObject={exObject}
                  setExContactedBy={setExContactedBy}
                  setExContactedMethod={setExContactedMethod}
                  setExDateCreated={setExDateCreated}
                  backupData={backupData}
                  setBackupData={setBackupData}
                  setEmailButtonClicked={setEmailButtonClicked}
                  setSelectedConsulData={setSelectedConsulData}
                  setEmailDetails={setEmailDetails}
                  setComposeEmail={setComposeEmail}
                  doRefresh={doRefresh}
                  setDoRefresh={setDoRefresh}
                  currentExpertID={currentExpertID}
                  setCurrentExpertID={setCurrentExpertID}
                /> */}
                <button
                  className="btn"
                  style={{ width: "130px" }}
                  onClick={() => getFollowupTemplate()}
                >
                  <i className="fa fa-envelope" title="Click to Email" />{" "}
                  Follow-Up
                </button>
                {isFollowLoading && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <i class="fa-solid fa-spinner fa-spin text-9xl text-[#365561]" />
                  </div>
                )}
                {/* <SendFollowUpEmail
                  expert={data?.expert}
                  project_id={project_id}
                  project_name={project_name}
                  exObject={exObject}
                  setExContactedBy={setExContactedBy}
                  setExContactedMethod={setExContactedMethod}
                  setExDateCreated={setExDateCreated}
                  backupData={backupData}
                  setBackupData={setBackupData}
                  setEmailButtonClicked={setEmailButtonClicked}
                  setSelectedConsulData={setSelectedConsulData}
                  setEmailDetails={setEmailDetails}
                  setComposeEmail={setComposeEmail}
                  setCurrentExpertID={setCurrentExpertID}
                  doRefresh={doRefresh}
                  setDoRefresh={setDoRefresh}
                /> */}
                <LogInmail
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  setExContactedBy={setExContactedBy}
                  setExContactedMethod={setExContactedMethod}
                  setExDateCreated={setExDateCreated}
                  backupData={backupData}
                  setBackupData={setBackupData}
                  doRefresh={doRefresh}
                  setDoRefresh={setDoRefresh}
                  currentExpertID={currentExpertID}
                  setCurrentExpertID={setCurrentExpertID}
                  profileURL={exObject.expertLink}
                />
                <LogCalls
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                  setExContactedBy={setExContactedBy}
                  setExContactedMethod={setExContactedMethod}
                  setExDateCreated={setExDateCreated}
                  backupData={backupData}
                  setBackupData={setBackupData}
                  doRefresh={doRefresh}
                  setDoRefresh={setDoRefresh}
                  currentExpertID={currentExpertID}
                  setCurrentExpertID={setCurrentExpertID}
                />
                {/* <SendUndo expert_id={data?.expert.ID} project_id={project_id} /> */}
                {/* <ConnectionBtn
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                /> */}
              </div>
            </div>

            <div className="prjdetails-panel prjdetails-action-btn">
              <div className="prjdetails-btns-div position-relative">
                <ExZohoBtn
                  expert_id={data?.expert.ID}
                  in_zoho={data?.expert.in_zoho}
                  status={newStatus}
                  summLength={summLength}
                  setShowSummAlert={setShowSummAlert}
                  exObject={exObject}
                  project_id={project_id}
                />
                <ExCreateDigitalPPT
                  digitalExist={data?.digitalExist}
                  expert_id={data?.expert.ID}
                  project_id={project_id}
                />

                <Link
                  to={`/app/SimilarProfiles/${project_id}/${data.expert.ID}`}
                >
                  <button className="btn">
                    <i className="fa-solid fa-users-viewfinder" /> Similar
                    Profiles
                  </button>
                </Link>
                <AddToProject
                  expertID={data.expert.ID}
                  btnName={" Add to project"}
                />
              </div>
            </div>
          </div>{" "}
        </>
      ) : (
        <div className="prjdetails-row-top" style={{ height: "250px" }}></div>
      )}
      <div className="prjdetails-row-bottom">
        <div
          style={{
            float: "left",
            marginLeft: "11px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {showComment && (
            <ExAvailabilityComment
              key={data?.expert.ID}
              comment={availabilityComment}
              expert_id={data?.expert.ID}
              setAvailabilityComment={setAvailabilityComment}
              backupData={backupData}
              setBackupData={setBackupData}
              setShowComment={setShowComment}
            />
          )}
          <div
            className="topCon-available-date"
            style={{ marginRight: "15px" }}
          >
            <i
              className="calender-icon fa-regular fa-calendar-days"
              style={{ marginRight: "11px" }}
            ></i>
            <label>Availability</label>
            <div className="inline-block group">
              <i
                className={
                  availabilityComment
                    ? "comment-icon fa-solid fa-comment-dots"
                    : "comment-icon comment-empty fa-regular fa-comment-dots"
                }
                onClick={() => setShowComment(!showComment)}
                style={{
                  left: "98px",
                  color: availabilityComment ? "#365561" : "grey",
                  cursor: "pointer",
                }}
              ></i>

              {availabilityComment && (
                <div className="absolute left-[150px] -translate-x-1/2 top-10 w-max max-w-xs bg-[#365561] text-white text-sm px-3 py-1 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none">
                  {availabilityComment}
                </div>
              )}
            </div>
            <ExAvailabilityDate
              key={data?.expert.ID}
              date={data?.expert.Available_from}
              expertID={data?.expert.ID}
              setAvailablityDate={setAvailablityDate}
              backupData={backupData}
              setBackupData={setBackupData}
            />
          </div>

          {appointmentExist ? (
            <>
              <div className="call-setup-div">
                <button
                  type="button"
                  className="call-setup-btn tooltip-shareProfile"
                  onClick={() => setOpenCall(true)}
                  style={{ backgroundColor: "#f9f9f9" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="23"
                    height="23"
                    viewBox="0 0 55 55"
                    fill="currentcolor"
                  >
                    <path d="M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z"></path>
                  </svg>
                  <span className="tooltip-text">View Calls</span>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="call-setup-div">
                <button
                  type="button"
                  className="call-setup-btn tooltip-shareProfile"
                  onClick={() => setOpenCall(true)}
                  style={{ backgroundColor: "#f9f9f9" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="23"
                    height="23"
                    viewBox="0 0 55 55"
                    fill="currentcolor"
                  >
                    <path d="M 27 4 C 23.145666 4 20 7.1456661 20 11 C 20 11.694215 20.109343 12.364062 20.298828 13 L 5 13 C 3.3550302 13 2 14.35503 2 16 L 2 34 C 2 35.64497 3.3550302 37 5 37 L 16.050781 37 C 16.558532 42.596375 21.274041 47 27 47 C 32.119276 47 36.240954 43.409081 37.460938 38.664062 C 38.643436 39.440841 39.984387 40 41.5 40 C 45.63039 40 49 36.63039 49 32.5 L 49 21 A 1.0001 1.0001 0 0 0 48 20 L 37 20 L 26 20 L 26 17.923828 C 26.327632 17.970927 26.660365 18 27 18 C 30.854334 18 34 14.854334 34 11 C 34 7.1456661 30.854334 4 27 4 z M 27 6 C 29.773666 6 32 8.2263339 32 11 C 32 13.773666 29.773666 16 27 16 C 26.651336 16 26.315457 15.955685 25.988281 15.888672 C 25.927569 14.29544 24.606899 13 23 13 L 22.421875 13 C 22.153458 12.388243 22 11.715897 22 11 C 22 8.2263339 24.226334 6 27 6 z M 42 8 C 40.416667 8 39.101892 8.6297556 38.251953 9.5859375 C 37.402014 10.542119 37 11.777778 37 13 C 37 14.222222 37.402014 15.457881 38.251953 16.414062 C 39.101892 17.370244 40.416667 18 42 18 C 43.583333 18 44.898108 17.370244 45.748047 16.414062 C 46.597986 15.457881 47 14.222222 47 13 C 47 11.777778 46.597986 10.542119 45.748047 9.5859375 C 44.898108 8.6297556 43.583333 8 42 8 z M 42 10 C 43.083333 10 43.768559 10.370244 44.251953 10.914062 C 44.735347 11.457882 45 12.222222 45 13 C 45 13.777778 44.735347 14.542119 44.251953 15.085938 C 43.768559 15.629755 43.083333 16 42 16 C 40.916667 16 40.231441 15.629756 39.748047 15.085938 C 39.264653 14.542118 39 13.777778 39 13 C 39 12.222222 39.264653 11.457881 39.748047 10.914062 C 40.231441 10.370245 40.916667 10 42 10 z M 5 15 L 21.757812 15 L 23 15 C 23.56503 15 24 15.43497 24 16 L 24 16.365234 A 1.0001 1.0001 0 0 0 24 16.919922 L 24 20.832031 A 1.0001 1.0001 0 0 0 24 21.158203 L 24 34 C 24 34.56503 23.56503 35 23 35 L 17.167969 35 A 1.0001 1.0001 0 0 0 16.841797 35 L 5 35 C 4.4349698 35 4 34.56503 4 34 L 4 16 C 4 15.43497 4.4349698 15 5 15 z M 9 19 L 9 21 L 13 21 L 13 31 L 15 31 L 15 21 L 19 21 L 19 19 L 9 19 z M 26 22 L 36 22 L 36 36 C 36 40.982593 31.982593 45 27 45 C 22.356014 45 18.554378 41.508579 18.058594 37 L 23 37 C 24.64497 37 26 35.64497 26 34 L 26 22 z M 38 22 L 47 22 L 47 32.5 C 47 35.54961 44.54961 38 41.5 38 C 40.097088 38 38.851397 37.45098 37.880859 36.591797 C 37.89251 36.384961 38 36.209688 38 36 L 38 22 z"></path>
                  </svg>
                  <span className="tooltip-text">Setup Calls</span>
                </button>
              </div>
              {/* {invitationRequest ? (
                <InviteToProject
                  key={data?.expert.ID}
                  projectID={project_id}
                  projectType={projectType}
                  inviteName={inviteName}
                  data={data}
                  onClose={() => setInvitationRequest(false)}
                  onSend={console.log("send")}
                  project_name={project_name}
                  setInviteButtonName={setInviteButtonName}
                />
              ) : null} */}
            </>
          )}

          <div style={{ marginLeft: "15px" }}>
            {data.recordConsent === null ? (
              <span>Didn't give record consent yet</span>
            ) : data.recordConsent === false ? (
              <span style={{ color: "red" }}>
                Does not agree to being recorded
              </span>
            ) : (
              <span style={{ color: "green" }}>Agrees to being recorded</span>
            )}
          </div>
        </div>
        <div>
          {/* Bappi: are we using it? */}
          {availability?.length > 0 ? (
            <span
              onClick={() => {
                setAvailabilityPopup(true);
              }}
            >
              Check availability for a call
            </span>
          ) : null}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <ExContactedDate
            key={data?.expert.ID}
            data={data}
            doRefresh={doRefresh}
            setDoRefresh={setDoRefresh}
            currentExpertID={currentExpertID}
            setCurrentExpertID={setCurrentExpertID}
          />
          <ExAddedDate
            // key={data?.expert.ID}
            addedTime={data?.expertAdded}
            addedBy={data?.expertAddedBy}
          />
          <ProjectExpertDelete
            // key={data?.expert.ID}
            expert_id={data?.expert.ID}
            project_id={project_id}
            setHideDeletedRow={setHideDeletedRow}
            tableData={tableData}
            setTableData={setTableData}
            backupData={backupData}
            setBackupData={setBackupData}
          />
        </div>
      </div>
      {availabilityPopup ? (
        <div className="appointment-wrapper">
          <AvailabilityCalendar
            availability={availability}
            setAvailability={setAvailability}
            setAvailabilityForm={setAvailabilityPopup}
          />
        </div>
      ) : null}
      {openCall && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-30">
          {/* <AppointmentScheduler
            projectID={project_id}
            expertID={data.expert.ID}
            setAppointmentExist={setAppointmentExist}
            openCall={openCall}
            setOpenCall={setOpenCall}
          /> */}
          <EphCalendar 
            projectID={project_id}
            expertID={data.expert.ID}
            setOpenCall={setOpenCall}
            setAppointmentExist={setAppointmentExist}
          />
        </div>
      )}
      {invitationRequest && (
        <ComposeNewEmail
          onClose={() => setInvitationRequest(false)}
          defaultTo={[data?.expert?.email]}
          defaultTemplates={defaultInviteTemplates}
          setSuccess={setIsSuccess}
          callingFrom={'Invite'}
          projectID={project_id}
        />
      )}
      {openEmail && (
        <ComposeNewEmail
          onClose={() => setOpenEmail(false)}
          defaultTo={[data?.expert.email]}
          defaultTemplates={defaultEmailTemplates}
          callingFrom={'Email'}
          projectID={project_id}
        />
      )}
      {folloupEmail && (
        <ComposeNewEmail
          onClose={() => setFolloupEmail(false)}
          defaultTo={[data?.expert?.email]}
          defaultTemplates={defaultFollowupTemplates}
          callingFrom={'FollowUp'}
          projectID={project_id}
        />
      )}

      {isModifyDeadline && (
        <ModifyProjectDeadline
          projectID={project_id}
          projectDeadline={projectDeadline}
          setIsModifyDeadline={setIsModifyDeadline}
        />
      )}
      <CvContactPreviewModal
        open={Boolean(cvPreviewFile)}
        file={cvPreviewFile}
        expertID={data?.expert?.ID}
        expertName={data?.expert?.Name}
        existingEmail={data?.expert?.email}
        existingPhone={data?.expert?.phone_n}
        onClose={() => setCvPreviewFile(null)}
        onUploaded={(payload) => {
          if (payload?.status === "success") {
            setDoRefresh?.(previous => !previous);
          }
        }}
      />
    </div>
  );
}
